// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-tabs__tabs-root {
    margin-top: 10px;
    border-bottom: 1px solid #bdbdbd;
}

.filter-tabs__tab-indicator {
    background-color: #1890ff !important;
}

.filter-tabs__tab-root:hover {
    color: #424242;
    background-color: #BDBDBD19;
}

.filter-tabs__tab-root--selected:hover {
    background-color: #1481F719;
}

.filter-tabs__tab-root.filter-tabs__tab-root--selected {
    color: #1890ff;
}

.filter-tabs__tab-container {
    padding: 24px;
    min-height: 165px;
    text-transform: none;
}
`, "",{"version":3,"sources":["webpack://./js/components/library/mui4/Tabs/Tabs.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;AACxB","sourcesContent":[".filter-tabs__tabs-root {\n    margin-top: 10px;\n    border-bottom: 1px solid #bdbdbd;\n}\n\n.filter-tabs__tab-indicator {\n    background-color: #1890ff !important;\n}\n\n.filter-tabs__tab-root:hover {\n    color: #424242;\n    background-color: #BDBDBD19;\n}\n\n.filter-tabs__tab-root--selected:hover {\n    background-color: #1481F719;\n}\n\n.filter-tabs__tab-root.filter-tabs__tab-root--selected {\n    color: #1890ff;\n}\n\n.filter-tabs__tab-container {\n    padding: 24px;\n    min-height: 165px;\n    text-transform: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
